/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAgendadosRouteImport } from './routes/_app/agendados'
import { Route as AppCampanhasRouteImport } from './routes/_app/campanhas'
import { Route as AppConfiguracoesRouteImport } from './routes/_app/configuracoes'
import { Route as AppContasRouteImport } from './routes/_app/contas'
import { Route as AppContatosRouteImport } from './routes/_app/contatos'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppRelatoriosRouteImport } from './routes/_app/relatorios'
import { Route as AppRespostasRouteImport } from './routes/_app/respostas'
import { Route as AppTagsRouteImport } from './routes/_app/tags'
import { Route as AppTransmissaoRouteImport } from './routes/_app/transmissao'
import { Route as ConviteTokenRouteImport } from './routes/convite.$token'
import { Route as AppAutomacoesIndexRouteImport } from './routes/_app/automacoes.index'
import { Route as AppAutomacoesIdRouteImport } from './routes/_app/automacoes.$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgendadosRoute = AppAgendadosRouteImport.update({
  id: '/agendados',
  path: '/agendados',
  getParentRoute: () => AppRoute,
} as any)
const AppCampanhasRoute = AppCampanhasRouteImport.update({
  id: '/campanhas',
  path: '/campanhas',
  getParentRoute: () => AppRoute,
} as any)
const AppConfiguracoesRoute = AppConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => AppRoute,
} as any)
const AppContasRoute = AppContasRouteImport.update({
  id: '/contas',
  path: '/contas',
  getParentRoute: () => AppRoute,
} as any)
const AppContatosRoute = AppContatosRouteImport.update({
  id: '/contatos',
  path: '/contatos',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppRelatoriosRoute = AppRelatoriosRouteImport.update({
  id: '/relatorios',
  path: '/relatorios',
  getParentRoute: () => AppRoute,
} as any)
const AppRespostasRoute = AppRespostasRouteImport.update({
  id: '/respostas',
  path: '/respostas',
  getParentRoute: () => AppRoute,
} as any)
const AppTagsRoute = AppTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AppRoute,
} as any)
const AppTransmissaoRoute = AppTransmissaoRouteImport.update({
  id: '/transmissao',
  path: '/transmissao',
  getParentRoute: () => AppRoute,
} as any)
const ConviteTokenRoute = ConviteTokenRouteImport.update({
  id: '/convite/$token',
  path: '/convite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAutomacoesIndexRoute = AppAutomacoesIndexRouteImport.update({
  id: '/automacoes/',
  path: '/automacoes/',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomacoesIdRoute = AppAutomacoesIdRouteImport.update({
  id: '/automacoes/$id',
  path: '/automacoes/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/agendados': typeof AppAgendadosRoute
  '/campanhas': typeof AppCampanhasRoute
  '/configuracoes': typeof AppConfiguracoesRoute
  '/contas': typeof AppContasRoute
  '/contatos': typeof AppContatosRoute
  '/inbox': typeof AppInboxRoute
  '/relatorios': typeof AppRelatoriosRoute
  '/respostas': typeof AppRespostasRoute
  '/tags': typeof AppTagsRoute
  '/transmissao': typeof AppTransmissaoRoute
  '/convite/$token': typeof ConviteTokenRoute
  '/automacoes/$id': typeof AppAutomacoesIdRoute
  '/automacoes/': typeof AppAutomacoesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/agendados': typeof AppAgendadosRoute
  '/campanhas': typeof AppCampanhasRoute
  '/configuracoes': typeof AppConfiguracoesRoute
  '/contas': typeof AppContasRoute
  '/contatos': typeof AppContatosRoute
  '/inbox': typeof AppInboxRoute
  '/relatorios': typeof AppRelatoriosRoute
  '/respostas': typeof AppRespostasRoute
  '/tags': typeof AppTagsRoute
  '/transmissao': typeof AppTransmissaoRoute
  '/convite/$token': typeof ConviteTokenRoute
  '/': typeof AppIndexRoute
  '/automacoes/$id': typeof AppAutomacoesIdRoute
  '/automacoes': typeof AppAutomacoesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/agendados': typeof AppAgendadosRoute
  '/_app/campanhas': typeof AppCampanhasRoute
  '/_app/configuracoes': typeof AppConfiguracoesRoute
  '/_app/contas': typeof AppContasRoute
  '/_app/contatos': typeof AppContatosRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/relatorios': typeof AppRelatoriosRoute
  '/_app/respostas': typeof AppRespostasRoute
  '/_app/tags': typeof AppTagsRoute
  '/_app/transmissao': typeof AppTransmissaoRoute
  '/convite/$token': typeof ConviteTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/automacoes/$id': typeof AppAutomacoesIdRoute
  '/_app/automacoes/': typeof AppAutomacoesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/agendados'
    | '/campanhas'
    | '/configuracoes'
    | '/contas'
    | '/contatos'
    | '/inbox'
    | '/relatorios'
    | '/respostas'
    | '/tags'
    | '/transmissao'
    | '/convite/$token'
    | '/automacoes/$id'
    | '/automacoes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/agendados'
    | '/campanhas'
    | '/configuracoes'
    | '/contas'
    | '/contatos'
    | '/inbox'
    | '/relatorios'
    | '/respostas'
    | '/tags'
    | '/transmissao'
    | '/convite/$token'
    | '/'
    | '/automacoes/$id'
    | '/automacoes'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/agendados'
    | '/_app/campanhas'
    | '/_app/configuracoes'
    | '/_app/contas'
    | '/_app/contatos'
    | '/_app/inbox'
    | '/_app/relatorios'
    | '/_app/respostas'
    | '/_app/tags'
    | '/_app/transmissao'
    | '/convite/$token'
    | '/_app/'
    | '/_app/automacoes/$id'
    | '/_app/automacoes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  ConviteTokenRoute: typeof ConviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agendados': {
      id: '/_app/agendados'
      path: '/agendados'
      fullPath: '/agendados'
      preLoaderRoute: typeof AppAgendadosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/campanhas': {
      id: '/_app/campanhas'
      path: '/campanhas'
      fullPath: '/campanhas'
      preLoaderRoute: typeof AppCampanhasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/configuracoes': {
      id: '/_app/configuracoes'
      path: '/configuracoes'
      fullPath: '/configuracoes'
      preLoaderRoute: typeof AppConfiguracoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas': {
      id: '/_app/contas'
      path: '/contas'
      fullPath: '/contas'
      preLoaderRoute: typeof AppContasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contatos': {
      id: '/_app/contatos'
      path: '/contatos'
      fullPath: '/contatos'
      preLoaderRoute: typeof AppContatosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/relatorios': {
      id: '/_app/relatorios'
      path: '/relatorios'
      fullPath: '/relatorios'
      preLoaderRoute: typeof AppRelatoriosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/respostas': {
      id: '/_app/respostas'
      path: '/respostas'
      fullPath: '/respostas'
      preLoaderRoute: typeof AppRespostasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tags': {
      id: '/_app/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof AppTagsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transmissao': {
      id: '/_app/transmissao'
      path: '/transmissao'
      fullPath: '/transmissao'
      preLoaderRoute: typeof AppTransmissaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/convite/$token': {
      id: '/convite/$token'
      path: '/convite/$token'
      fullPath: '/convite/$token'
      preLoaderRoute: typeof ConviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/automacoes/': {
      id: '/_app/automacoes/'
      path: '/automacoes'
      fullPath: '/automacoes/'
      preLoaderRoute: typeof AppAutomacoesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automacoes/$id': {
      id: '/_app/automacoes/$id'
      path: '/automacoes/$id'
      fullPath: '/automacoes/$id'
      preLoaderRoute: typeof AppAutomacoesIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAgendadosRoute: typeof AppAgendadosRoute
  AppCampanhasRoute: typeof AppCampanhasRoute
  AppConfiguracoesRoute: typeof AppConfiguracoesRoute
  AppContasRoute: typeof AppContasRoute
  AppContatosRoute: typeof AppContatosRoute
  AppInboxRoute: typeof AppInboxRoute
  AppRelatoriosRoute: typeof AppRelatoriosRoute
  AppRespostasRoute: typeof AppRespostasRoute
  AppTagsRoute: typeof AppTagsRoute
  AppTransmissaoRoute: typeof AppTransmissaoRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAutomacoesIdRoute: typeof AppAutomacoesIdRoute
  AppAutomacoesIndexRoute: typeof AppAutomacoesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAgendadosRoute: AppAgendadosRoute,
  AppCampanhasRoute: AppCampanhasRoute,
  AppConfiguracoesRoute: AppConfiguracoesRoute,
  AppContasRoute: AppContasRoute,
  AppContatosRoute: AppContatosRoute,
  AppInboxRoute: AppInboxRoute,
  AppRelatoriosRoute: AppRelatoriosRoute,
  AppRespostasRoute: AppRespostasRoute,
  AppTagsRoute: AppTagsRoute,
  AppTransmissaoRoute: AppTransmissaoRoute,
  AppIndexRoute: AppIndexRoute,
  AppAutomacoesIdRoute: AppAutomacoesIdRoute,
  AppAutomacoesIndexRoute: AppAutomacoesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  ConviteTokenRoute: ConviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
